import type { RouteObject } from "react-router-dom";
import { redirect } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import {
  MsSalesCommissions,
  MsMySalesPage,
  MsMyCommissionPage,
  MsSaleCreate,
  MsSaleEdit,
  MsSaleDetail,
} from "@/utils/lazyLoadComponents";

export enum MS_SALES_PATH_SEGMENTS {
  ROOT = "sales-commissions",
  MY_SALES = "my-sales",
  MY_COMMISSION = "my-commission",
  CREATE = "create",
  EDIT = ":id/edit",
  DETAILS = ":id",
}

export const mySpaceSalesCommissionsRoutes: RouteObject = {
  path: MS_SALES_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Sales & Commissions" },
  HydrateFallback: Spinner,
  children: [
    // ── Page-level tabs layout: each tab owns its own stats + table ──────────
    {
      Component: MsSalesCommissions,
      handle: { flushContent: true },
      children: [
        {
          index: true,
          loader: () => redirect(MS_SALES_PATH_SEGMENTS.MY_SALES),
        },
        {
          path: MS_SALES_PATH_SEGMENTS.MY_SALES,
          handle: { breadcrumb: "My Sales" },
          Component: MsMySalesPage,
        },
        {
          path: MS_SALES_PATH_SEGMENTS.MY_COMMISSION,
          handle: { breadcrumb: "My Commission" },
          Component: MsMyCommissionPage,
        },
      ],
    },
    {
      path: MS_SALES_PATH_SEGMENTS.CREATE,
      handle: { breadcrumb: "Log a Sale" },
      Component: MsSaleCreate,
    },
    {
      path: MS_SALES_PATH_SEGMENTS.EDIT,
      handle: { breadcrumb: "Edit Sale" },
      Component: MsSaleEdit,
    },
    {
      path: MS_SALES_PATH_SEGMENTS.DETAILS,
      handle: { breadcrumb: "Sale Details" },
      Component: MsSaleDetail,
    },
  ],
};

export const MS_SALES_PATHS = Object.freeze({
  ROOT: addSlashes(MS_SALES_PATH_SEGMENTS.ROOT),
  MY_SALES: addSlashes(
    MS_SALES_PATH_SEGMENTS.ROOT,
    MS_SALES_PATH_SEGMENTS.MY_SALES,
  ),
  MY_COMMISSION: addSlashes(
    MS_SALES_PATH_SEGMENTS.ROOT,
    MS_SALES_PATH_SEGMENTS.MY_COMMISSION,
  ),
  CREATE: addSlashes(
    MS_SALES_PATH_SEGMENTS.ROOT,
    MS_SALES_PATH_SEGMENTS.CREATE,
  ),
  EDIT: (id: string | number) =>
    addSlashes(MS_SALES_PATH_SEGMENTS.ROOT, String(id), "edit"),
  DETAIL: (id: string | number) =>
    addSlashes(MS_SALES_PATH_SEGMENTS.ROOT, String(id)),
});
